import { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import "../styles/Layout.css";

function Layout() {

  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {

    const handleClickOutside = (e) => {

      if (
        window.innerWidth <= 992 &&
        !e.target.closest(".sidebar") &&
        !e.target.closest(".menu-btn")
      ) {
        setSidebarOpen(false);
      }

    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };

  }, []);

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} />

      <Header
        toggleSidebar={() =>
          setSidebarOpen(!sidebarOpen)
        }
      />

      <div className="main-content">
        <Outlet />
      </div>

      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </>
  );
}

export default Layout;